import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Chrome Translate et certaines extensions (Grammarly, etc.) remplacent les
// nœuds texte gérés par React → NotFoundError en réconciliation
// (insertBefore/removeChild), vu en prod sur le Site Builder. On tolère ces
// nœuds déplacés au lieu de laisser React planter. Cf. React issue #11538.
let warnedRemove = false;
let warnedInsert = false;
function installDomMutationGuard() {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (!warnedRemove) {
        warnedRemove = true;
        console.warn("[dom-guard] removeChild ignored: node moved by an extension (e.g. auto-translate)");
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (!warnedInsert) {
        warnedInsert = true;
        console.warn("[dom-guard] insertBefore ignored: node moved by an extension (e.g. auto-translate)");
      }
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
installDomMutationGuard();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
